<template>
  <div class="base-block-new">
    <div class="baseinfo-box">
      <div class="baseinfo-header">
        <div class="base-left">
          <span class="base-name">{{ baseInfo.classroomName }}</span>
          <span>{{ baseInfo.schoolName }}</span>
          <span>{{ baseInfo.branchName }}</span>
        </div>
        <div class="base-right">
          <div
            v-if="canOperateData && baseInfo.registeredNumbers === 0"
            class="del-btn-430"
            @click="handleDelClass"
          >
            删除
          </div>
          <div
            v-if="canEditClassData"
            class="click-btn-430"
            @click="handleToEdit"
          >
            编辑
          </div>
        </div>
      </div>
      <!-- <div class="baseinfo-content">
        <Form ref="baseInfo" :label-width="110" inline>
          <Row type="flex" justify="center">
            <Col span="7">
              <FormItem label="班级ID：">
                {{ baseInfo.classroomId }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="课程类别：">
                {{ classTypeList[baseInfo.classType] }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="课程分类：">
                {{ baseInfo.courseTypeName }}
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="center">
            <Col span="7">
              <FormItem label="商品ID：">
                {{ baseInfo.relClassroomId }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="商品名称：">
                {{ baseInfo.relClassroomName }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="总课时：">
                {{ baseInfo.classroomTotal }}
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="center">
            <Col span="7">
              <FormItem label="学期：">
                {{ baseInfo.termName }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="开课日期：">
                {{ baseInfo.classDateBegin }}
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="上课场地：">
                {{ baseInfo.placeName }}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div> -->
    </div>
    <Modal
      v-model="modalShow"
      title="编辑课班信息"
      :footer-hide="true"
      :closable="false"
    >
      <span class="modal-tips">班级信息修改后将自动同步至家长查看课程班级</span>
      <Form
        ref="modal"
        :model="classInfoForm"
        :rules="ruleClassInfoForm"
        :label-width="100"
      >
        <FormItem label="班级名称:" prop="classroomName">
          <Input
            v-model="classInfoForm.classroomName"
            class="form-line-content"
            placeholder="请输入班级名称"
          ></Input>
          <div class="code-text">班级名称最多50个字</div>
        </FormItem>
        <FormItem v-if="modalShow" label="上课地点:" prop="placeId">
          <PlaceSelect
            ref="placeSelectRef"
            v-model="classInfoForm"
            :org-id="baseInfo.schoolId"
            :branch-id="baseInfo.branchId"
          ></PlaceSelect>
          <div class="code-text">确定请按 Enter（回车）键</div>
        </FormItem>
        <FormItem label="班级群二维码:" prop="codeImg">
          <div class="img-box">
            <div v-if="classInfoForm.codeImg" class="img-block">
              <div class="rightBox"></div>
              <img
                v-if="classInfoForm.codeImg.imgShow"
                class="img-set"
                :src="classInfoForm.codeImg.imgShow"
                alt=""
              >
              <img
                v-else-if="classInfoForm.codeImg.fileId"
                class="img-set"
                :src="downloadUrl + '?fileId=' + classInfoForm.codeImg.fileId"
                alt=""
              >
              <Icon
                type="ios-close"
                size="30"
                class="del-btn"
                @click="handleDelImg"
              ></Icon>
            </div>
            <UploadBtn
              v-else
              text="上传班级群二维码"
              class="ml-2"
              @on-success="handleUploadImg"
            ></UploadBtn>
          </div>
          <div class="code-text">家长可通过扫描识别此二维码进群</div>
        </FormItem>
      </Form>
      <div class="btn-block">
        <Button @click="handleCancleModal">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import UploadBtn from '@c/UploadBtn';
import { mapState } from 'vuex';
import { readFileOfImage } from '@/utils/utils.js';
import axios from 'axios';
import PlaceSelect from '@pv/courseSchedulCenter/assets/components/PlaceSelect';
export default {
  components: {
    UploadBtn,
    PlaceSelect
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => { }
    },
    teachersData: {
      type: Array,
      default: () => []
    },
    // 是否可以操作数据
    canOperateData: {
      type: Boolean,
      default: false
    },
    // 是否可以编辑课班数据
    canEditClassData: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    // 班级名称校验
    const validateClassroomName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入班级名称'));
      } else if (value.length > 50) {
        callback(new Error('班级名称最多只能50个字'));
      } else {
        callback();
      }
    };
    return {
      modalShow: false, // 弹窗是否打开
      placeList: [], // 地点列表
      classInfoForm: {
        classroomId: '', // 课班Id
        classroomName: '', // 班级名称
        placeName: '',
        placeId: '', // 场地Id
        codeImg: null // 班级二维码
      },
      classTypeList: [
        '-',
        '课程',
        '托管'
      ], // 课程类别,1-课程 2-托管
      ruleClassInfoForm: {
        classroomName: [
          {
            required: true, validator: validateClassroomName, trigger: 'blur'
          }
        ]
        // placeId: [
        //   {
        //     required: true, message: '请选择上课地点', trigger: 'blur,change'
        //   }
        // ]
      },
      loading: false,
      fileId: '', // 班级码id
      portOrg: localStorage.getItem('portOrg')
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
  },
  methods: {
    // 删除班级
    handleDelClass() {
      this.$Modal.confirm({
        title: '提示',
        content: `是否删除${this.baseInfo.classroomName}？删除后不可恢复！`,
        onOk: () => {
          this.delListItemTrue();
        }
      });
    },
    // 真正的删除
    async delListItemTrue() {
      const params = {
        classroomId: this.baseInfo.classroomId
      };
      const res = await courseSchedulCenter.delCourseClassItemApi(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        // this.$router.push({
        //   name: 'courseSchedulCenter_divideClassManage_list'
        // });
        this.$emit('delClass');
      }
    },
    handleToEdit() {
      this.classInfoForm.classroomName = this.baseInfo.classroomName;
      if (+this.baseInfo.placeId === 0 && this.baseInfo.placeName) {
        // this.placeList = [{
        //   placeId: this.baseInfo.placeName,
        //   placeName: this.baseInfo.placeName
        // }];
        this.classInfoForm.placeId = this.baseInfo.placeName;
        this.classInfoForm.placeName = this.baseInfo.placeName;
      } else {
        this.classInfoForm.placeId = this.baseInfo.placeName ? this.baseInfo.placeId : '';
      }
      this.baseInfo.courseQrCode && (+this.baseInfo.courseQrCode) !== 0 ? this.classInfoForm.codeImg = { fileId: this.baseInfo.courseQrCode } : '';
      // if (this.classInfoForm.placeId && +this.classInfoForm.placeId !== 0) {
      //   this.beforeGetPlaceList();
      // }
      this.modalShow = true;
    },
    handleCancleModal() {
      this.$refs.modal.resetFields();
      this.modalShow = false;
    },
    async handleSubmit() {
      if (this.classInfoForm.codeImg) {
        this.fileId = await this.uploadImg(this.classInfoForm.codeImg);
      } else {
        this.fileId = '';
      }
      this.$refs.placeSelectRef.getPlaceId();
      console.log(this.$refs.placeSelectRef.getPlaceName());
      // return null
      this.$refs.modal.validate((valid) => {
        if (valid) {
          this.updateClassInfo();
        }
      });
    },
    // 更新班级信息
    async updateClassInfo() {
      this.classInfoForm.classroomId = this.baseInfo.classroomId;
      console.log(this.classInfoForm, ' this.classInfoForm');
      let { codeImg, placeName, placeId, ...paramsS } = this.classInfoForm;
      if (placeName !== '' && placeName === placeId) {
        placeId = 0;
      }
      const params = { placeId, ...paramsS, courseQrCode: this.fileId };
      // placeName ? params.placeName = placeName : '';
      if (placeId) {
        params.placeName = this.$refs.placeSelectRef.getPlaceName();
      } else {
        params.placeName = placeName;
      }

      // console.log('要更新的数据---', params);
      // return;
      const res = await courseSchedulCenter.updateClassInfo(params);
      if (res.status === 200) {
        this.$Message.success('更新班级信息成功');
        this.$emit('refresh');
        this.handleCancleModal();
      }
    },
    // // 获取场地
    // beforeGetPlaceList(query = null) {
    //   query ? '' : query = null;
    //   this.loading = true;
    //   this.getPlaceListData(query);
    // },
    // // 获取场地列表
    // async getPlaceListData(query) {
    //   if (!this.baseInfo.schoolId) {
    //     return;
    //   }
    //   const params = {
    //     orgId: this.baseInfo.schoolId, // 学校id
    //     // orgId: this.userInfo.orgId, // 学校id
    //     branchId: this.baseInfo.branchId, // 校区id
    //     searchStr: query, // 搜索关键字
    //     placeSts: 1, // 场地状态 1：启用 0：禁用
    //     pageNum: 1,
    //     pageSize: 100
    //   };
    //   const res = await schoolAdmin.getPlacesQuerylist(params);
    //   if (res.status === 200) {
    //     this.loading = false;
    //     this.placeList = res.message.list;
    //   }
    // },
    async handleUploadImg(files) {
      const file = files[0];
      try {
        const result = await readFileOfImage(file);
        if ((file.size / 1024) > 5 * 1024) {
          return this.$Message.error('图片不能大于5M，请重新上传');
        }
        const obj = {
          file: file,
          imgShow: result
        };
        this.$set(this.classInfoForm, 'codeImg', obj);
      } catch (error) {
        this.$Message.warning('读取图片失败');
      }
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          resolve(res);
        });
      });
    },
    async uploadImg(fileObj) {
      if (fileObj.fileId) {
        return fileObj.fileId;
      }
      return new Promise(async(resolve, reject) => {
        const file = fileObj.file;
        const formData = new FormData();
        const r = await this.getUploadtoken();
        const obj = { token: '', upUrl: '', downUrl: '' };
        if (r.status === 200) {
          Object.assign(obj, r.message);
        }

        formData.append('token', obj.token);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        axios.post(obj.upUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;
            resolve(id);
          } else {
            this.$Message.warning(res.data.error);
          }
        });
      });
    },
    handleDelImg() {
      this.classInfoForm.codeImg = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.baseinfo-box {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dcdee2;
  margin-top: 16px;
}
.baseinfo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.03);
  padding: 16px 24px;
  .base-left {
    display: flex;
    align-items: center;
    .base-name {
      font-weight: bold;
      font-size: 14px;
    }
    span + span {
      margin-left: 8px;
    }
  }
  .base-right {
    display: flex;
    align-items: center;
  }
}
.baseinfo-content {
  padding-top: 24px;
}
.base-block-new {
  /deep/.ivu-form-item-label {
    color: #999;
  }
}
.modal-tips {
  color: #488ffa;
}
form {
  margin-top: 16px;
}
.form-line-content {
  width: 200px;
}
.btn-block {
  text-align: right;
  button + button {
    margin-left: 16px;
  }
}
.img-box {
  display: flex;
}
.code-text {
  color: #999;
  // margin-top: 16px;
}
.img-block {
  position: relative;
  .del-btn {
    position: absolute;
    top: -5px;
    right: -5px;
    cursor: pointer;
    color: #fff;
  }
  .rightBox {
    width: 20px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
    position: absolute;
    top: 0;
    right: 0;
  }
  .img-set {
    // width: 100px;
    height: 100px;
  }
}
</style>
